import Vue from 'vue'
import App from './App.vue'
import router from './router' // 确保这里正确导入了路由配置
import i18n from './i18n';

Vue.config.productionTip = false
Vue.prototype.URL = "https://bike.typhcl.cn/md/apis.php";
Vue.prototype.jref =function(url){
	this.$router.push(url);
};
Vue.prototype.jref_r =function(url){
	this.$router.replace(url);
};
Vue.prototype.back =function(url){
	this.$router.back();
};
Vue.prototype.show_img =function(img){
	location.open=img;
	}
new Vue({
	 i18n,
  router, // 将路由配置加入到 Vue 实例中
  render: h => h(App),
}).$mount('#app')
